import { Platform } from '@angular/cdk/platform';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { LocationDataGeocoded } from '@sc/data-access-graphql';
import { Fitter } from '@sc/data-access-models';
import { ItineraryAltComponent } from './itinerary-alt/itinerary-alt.component';
import { ItineraryMainComponent } from './itinerary-main/itinerary-main.component';
import { NgIf } from '@angular/common';

@Component({
  selector: 'sc-itinerary',
  template: `
    <sc-itinerary-main
      *ngIf="!alt"
      (closeEvent)="cancel()"
      (itineraryClick)="openGMaps()"
    ></sc-itinerary-main>
    <sc-itinerary-alt
      *ngIf="alt"
      (closeEvent)="cancel()"
      (clickGMaps)="openGMaps()"
      (clickWaze)="openWaze()"
      (clickAppleMaps)="openAppleMaps()"
    ></sc-itinerary-alt>
  `,
  styleUrls: ['./itinerary.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [NgIf, ItineraryMainComponent, ItineraryAltComponent],
})
export class ItineraryComponent implements OnInit {
  private static readonly gmapsUrlBase = 'https://maps.google.com/';
  private static readonly gmapsUrlBaseApp = `${ItineraryComponent.gmapsUrlBase}maps`;
  private static readonly appleMapsUrlBase = 'http://maps.apple.com/';
  private static readonly wazeUrlBase = 'https://waze.com/ul';

  @Input() fitter: Fitter;
  @Input() userLocation: LocationDataGeocoded;
  @Input() alt = false;

  @Output() closeEvent = new EventEmitter<void>();

  userFormattedAddress;
  fitterFormattedAddress;

  constructor(private readonly platform: Platform) {}

  ngOnInit(): void {
    this.userFormattedAddress =
      this.userLocation?.address +
      ' ' +
      (this.userLocation?.addressElements?.city ?? '') +
      ' ' +
      (this.userLocation?.addressElements?.postalCode ?? '');
    this.fitterFormattedAddress =
      this.fitter?.address +
      ' ' +
      (this.fitter?.city ?? '') +
      ' ' +
      (this.fitter?.cp ?? '');
  }

  private openMap(url: string) {
    window.open(url);
    this.closeEvent.emit();
  }

  openGMaps() {
    let usedGMapsUrl = ItineraryComponent.gmapsUrlBaseApp;

    if (this.platform.IOS) {
      usedGMapsUrl = ItineraryComponent.gmapsUrlBase;
    }

    this.openMap(
      `${usedGMapsUrl}?saddr=${this.userFormattedAddress}&daddr=${this.fitterFormattedAddress}`
    );
  }

  openAppleMaps() {
    this.openMap(
      `${ItineraryComponent.appleMapsUrlBase}?saddr=${this.userFormattedAddress}&daddr=${this.fitterFormattedAddress}`
    );
  }

  openWaze() {
    this.openMap(
      `${ItineraryComponent.wazeUrlBase}?ll=${this.fitter.location.lat},${this.fitter.location.lon}`
    );
  }

  cancel() {
    this.closeEvent.emit();
  }
}
